import styled from "styled-components";

export const SettingsItem = styled.div`
  display: grid;
  grid-template-columns: 4rem auto;
  grid-auto-flow: column;
  cursor: pointer;
  margin: 0.5rem 0;
  align-items: center;
`;

export const SettingsItemLabel = styled.div`
  color: ${({ theme }) => theme.colors.black};
  grid-column: 2;
  grid-row: 1 / 2;
`;

export const SettingsItemDescription = styled.div`
  color: ${({ theme }) => theme.colors.gray};
  grid-column: 2;
  grid-row: 2 / 2;
`;

export const SettingsItemIcon = styled.div`
  color: ${({ theme }) => theme.colors.blueDianne};
  font-size: 2rem;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  justify-items: center;
  align-items: center;
`;
